// lib
import PropTypes from 'prop-types'

import QuestionIcon from '@aytm/app/stats/page/question-views/md/components/QuestionIcon'

// styles
import style from '@aytm/app/stats/page/question-views/md/styles/ControlsHead.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const ControlsHead = ({ maxDiffType }) => (
  <div className={`${style.head} ${NO_PRINT}`}>
    <div className={style.headIcon}>
      <QuestionIcon />
      <span className={style.headTitle}>
        Advanced
        <br />
        MaxDiff&nbsp;HB<sup>SM</sup>
      </span>
    </div>
    <span className={style.headInfo}>
      <b>Advanced MaxDiff HB</b>
      <sup>SM</sup> experiment is using Hierarchical Bayesian model to calculate alternatives&apos; utility scores on
      both individual and aggregate levels.{' '}
      {1 <= maxDiffType && (
        <a
          href="https://helpcenter.aytm.com/hc/en-us/articles/360048761692"
          title="Read more"
          target="_blank"
          rel="noreferrer"
        >
          Read more
        </a>
      )}
    </span>
  </div>
)

ControlsHead.propTypes = {
  maxDiffType: PropTypes.number
}

ControlsHead.displayName = 'ControlsHead'

export default ControlsHead
